import { Route, Routes } from "react-router-dom";
import Header from "./constants/header";
import Footer from "./constants/footer";
import ContactPage from "./pages/contact";
import HomePage from "./pages/home";
import AboutPage from "./pages/about";
import PlansPage from "./pages/plans";
import SubjectsPage from "./pages/subjects";
import SubjectWrapper from "./components/subjects-wrapper";
import PlansInfo from "./pages/plansinfo";
import GetStarted from "./pages/getstarted";
import Assessment from "./pages/assessment";
import Onboarding from "./pages/onboarding";

function App() {
  return (
    <div className="App">
      <Header />
      <Routes>
        <Route exact path="/" element={<HomePage />} />
        <Route exact path="/about" element={<AboutPage />} />
        <Route exact path="/contact" element={<ContactPage />} />
        <Route exact path="/subjects" element={<SubjectsPage />} />
        <Route exact path="/courses" element={<PlansPage />} />
        <Route path="/courses/:planKey" element={<PlansInfo />} />
        <Route path="/subjects/:slug" element={<SubjectWrapper />} />
        <Route path="/getstarted" element={<GetStarted />} />
        <Route path="/assessment" element={<Assessment />} />
        <Route path="/onboarding" element={<Onboarding />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
